import Cookie from 'js-cookie'

(function($) {
	var markViewed = function() {
		$('.navigation-wrapper .alert-status-button, .mobile-submenu-mobile-alerts-button .alert-status, .navigation-menu-button').removeClass('alert-status-active');
		$('.alert-widget-item').removeClass('new');
	}

	// Desktop
	$('.navigation-wrapper .alert-widget').each(function() {
		var $this = $(this);
		var closeWidget = function() {
			$this.removeClass('active');
			markViewed()
		}
		$this.find('.alert-status-button').click(function() {
			if (!$this.hasClass('active')) {
				$this.addClass('active');
				$(this).attr('aria-expanded', 'true');
				Cookie.set('ecu-alerts', (new Date()).toISOString(), { expires: 30 });
			}
			else {
				closeWidget()
				$(this).attr('aria-expanded', 'false');
			}
			return false;
		});
		$this.find('.close').click(function() {
			closeWidget()
			$this.find('.alert-status-button').attr('aria-expanded', 'false');
			return false;
		});
		$('body').click(function(e) {
			if (!jQuery.contains($this.get(0), e.target)) {
				if ($this.hasClass('active')) {
					closeWidget()
				}
			}
		});

	});

	$('.mobile-submenu-mobile-alerts-button').click(function() {
		if (!$(this).parent().hasClass('is-expanded')) {
			$('.navigation-menu-button').removeClass('alert-status-active');
			Cookie.set('ecu-alerts', (new Date()).toISOString(), { expires: 30 });
		}
		else {
			markViewed();
		}
	});

	var lastCheck = new Date(Cookie.get('ecu-alerts') || '2021-01-01'); // Anytime in the past...
	var showAlertActive = false;
	$('.alert-widget-item').each(function() {
		if (new Date($(this).data('timestamp-iso')) > lastCheck) {
			$(this).addClass('new');
			showAlertActive = true;
		}
	});
	if (showAlertActive) {
		$('.navigation-wrapper .alert-status-button, .mobile-submenu-mobile-alerts-button .alert-status, .navigation-menu-button').addClass('alert-status-active');
	}

})(jQuery);
